module.exports = "\n<div class=\"panel panel-default exchanges-box\" _v-d769e3e8=\"\">\n    <div class=\"panel-heading\" _v-d769e3e8=\"\">\n        Échanges hors contrat\n    </div>\n    <ul class=\"panel-body list-group\" _v-d769e3e8=\"\">\n        <exchange-row :ex=\"ex\" v-for=\"ex of client.exchanges\" _v-d769e3e8=\"\"></exchange-row>\n    </ul>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-d769e3e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/ExchangesBox.vue
// module id = 541
// module chunks = 0